/**
 * Deployment feature switches (build time).
 *
 * VITE_WARRANTY_ONLY=true limits the main menu to Warranty Lookup and sends every other main-menu address to it.
 * The Settings section at the bottom of the menu is not affected. Read at call time so tests can change it.
 */
export const isWarrantyOnly = (): boolean => import.meta.env.VITE_WARRANTY_ONLY === 'true';

/** Where a user lands, and where hidden addresses redirect to, when only Warranty Lookup is available. */
export const WARRANTY_ONLY_HOME = '/warranty';
